var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"nodata-tips [v-cloak]"},[(_vm.image.length > 0)?_c('img',{staticClass:"tip-photos",class:_vm.image,attrs:{"src":'images/'+ _vm.image +'.png'}}):_vm._e(),_c('div',{staticClass:"tips-content",class:_vm.image.length === 0 ? 'no-img':''},[_vm._t("default")],2)])
}
var staticRenderFns = []

export { render, staticRenderFns }